export const EYB_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_26b4e084-9002-47e7-8f3b-6b4b4ebe09a7/artifacts/75a8l4be_image.png";

export const TEMP_STYLES = {
  Cold: "bg-slate-100 text-slate-700 border border-slate-200",
  Warm: "bg-amber-50 text-amber-700 border border-amber-200",
  Hot: "bg-red-50 text-red-700 border border-red-200",
};

export const STAGE_STYLES = {
  "Need Assessment": "bg-sky-50 text-sky-700 border border-sky-200",
  "Formal Presentation": "bg-indigo-50 text-indigo-700 border border-indigo-200",
  "Decision Pending": "bg-amber-50 text-amber-700 border border-amber-200",
  "Closed Won": "bg-emerald-50 text-emerald-700 border border-emerald-200",
  "Closed Lost": "bg-rose-50 text-rose-700 border border-rose-200",
};

export const STATUS_STYLES = {
  New: "bg-sky-50 text-sky-700 border border-sky-200",
  Contacted: "bg-indigo-50 text-indigo-700 border border-indigo-200",
  Qualified: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Unqualified: "bg-slate-100 text-slate-600 border border-slate-200",
  Converted: "bg-[#29ABE2]/10 text-[#187199] border border-[#29ABE2]/30",
};

export function Pill({ children, className = "" }) {
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold ${className}`}>{children}</span>;
}
